const $window = $(window),
    $body = $('body'),
    $html = $('html');
let $mcaAcOp = $('#mcaAcOp');

let oftotop;

function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

{
    function webpBad() {
        console.log("webp is BAD.");
        document.documentElement.classList.add('no-webp');
    }
    let webpSrc = 'data:image/jpeg;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
    let image = new Image();
    image.onerror = webpBad;
    // image.onload = webpOk;
    image.src = webpSrc;
    // console.log("webpTest was ran.");


}

// for currency-convertor
let nameCurPar,curPar;
let dataCcode = $body.attr('data-ccur');
let lPar = 'CHF', rPar = 'EUR';
let cPar = lPar+'/'+rPar;